export default __webpack_public_path__ + "static/media/product-1-1.c10cb18a.jpg";